import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { CompanyMasterService } from '../_services/companyMaster.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    CompanyMasterActionTypes,
    CompanyMasterPageRequested,
    CompanyMasterPageLoaded,
    OneCompanyMasterDeleted,
    CompanyMasterActionToggleLoading,
    CompanyMasterPageToggleLoading,
    CompanyMasterUpdated,
    CompanyMasterCreated,
    CompanyMasterOnServerCreated
} from '../_actions/companyMaster.actions';
import { of } from 'rxjs';

@Injectable()
export class CompanyMasterEffects {
    showPageLoadingDistpatcher = new CompanyMasterPageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new CompanyMasterActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new CompanyMasterActionToggleLoading({ isLoading: false });

    @Effect()
    loadCompanyMasterPage$ = this.actions$.pipe(
        ofType<CompanyMasterPageRequested>(CompanyMasterActionTypes.CompanyMasterPageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.companyMasterService.findCompanyMasters(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];
            //console.log(result.items);
            const pageLoadedDispatch = new CompanyMasterPageLoaded({
                companyMasters: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteCompanyMaster$ = this.actions$
        .pipe(
            ofType<OneCompanyMasterDeleted>(CompanyMasterActionTypes.OneCompanyMasterDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.companyMasterService.deleteCompanyMaster(payload.CompanyMId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateCompanyMaster$ = this.actions$
        .pipe(
            ofType<CompanyMasterUpdated>(CompanyMasterActionTypes.CompanyMasterUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.companyMasterService.updateCompanyMaster(payload.companyMaster.CompanyMId, payload.companyMaster);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createCompanyMaster$ = this.actions$
        .pipe(
            ofType<CompanyMasterOnServerCreated>(CompanyMasterActionTypes.CompanyMasterOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.companyMasterService.createCompanyMaster(payload.companyMaster).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new CompanyMasterCreated({ companyMaster: res }));
                        if (res.CompanyMId == 0) {
                            this.store.dispatch(new CompanyMasterCreated({ companyMaster: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new CompanyMasterErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private companyMasterService: CompanyMasterService, private store: Store<AppState>) { }
}
